import { IconButton, Typography, Box } from "@mui/material";
import React, { Fragment } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  NavigateBefore,
  NavigateNext,
  FirstPage,
  LastPage,
  SaveAlt,
  Remove,
  Add,
  Close,
} from "@mui/icons-material";

const PdfControlButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  padding: "8px",
}));

const Controls = (props) => {
  const theme = useTheme();
  const {
    numPages,
    downloadFile,
    page,
    scale,
    onScale,
    onSetPage,
    children,
    onClose,
  } = props;

  const ScaleButtons = () => {
    return (
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <PdfControlButton
          disabled={scale <= 0.25}
          onClick={() => onScale(scale - 0.25)}
        >
          <Remove />
        </PdfControlButton>
        <Typography variant="body1" color="primary" sx={{ mx: 1 }}>
          {scale * 100}%
        </Typography>
        <PdfControlButton onClick={() => onScale(scale + 0.25)}>
          <Add />
        </PdfControlButton>
      </Box>
    );
  };

  const SkipButtons = () => {
    return (
      <Fragment>
        <PdfControlButton disabled={page === 1} onClick={() => onSetPage(1)}>
          <FirstPage />
        </PdfControlButton>
        <PdfControlButton
          disabled={page === 1}
          onClick={() => onSetPage(page - 1)}
        >
          <NavigateBefore />
        </PdfControlButton>

        <Typography variant="body1" color="primary" sx={{ mx: 1 }}>
          {page} / {numPages}
        </Typography>

        <PdfControlButton
          disabled={page === numPages}
          onClick={() => onSetPage(page + 1)}
        >
          <NavigateNext />
        </PdfControlButton>
        <PdfControlButton
          disabled={page === numPages}
          onClick={() => onSetPage(numPages)}
        >
          <LastPage />
        </PdfControlButton>
      </Fragment>
    );
  };

  const downloadButton = (
    <PdfControlButton onClick={downloadFile}>
      <SaveAlt />
    </PdfControlButton>
  );

  const closeButton = (
    <PdfControlButton onClick={onClose}>
      <Close />
    </PdfControlButton>
  );

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 6px",
          backgroundColor: theme.palette.common.white,
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.31)",
          left: 0,
          right: 0,
          position: "fixed",
          top: 0,
        }}
      >
        {downloadButton}
        <ScaleButtons />
        {closeButton}
      </Box>

      {children}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: theme.palette.common.white,
          boxShadow: "0 -2px 4px 0 rgba(0, 0, 0, 0.31)",
          left: 0,
          right: 0,
          position: "fixed",
          bottom: 0,
          padding: "8px 56px",
        }}
      >
        <SkipButtons />
      </Box>
    </Fragment>
  );
};

export default Controls;
